
import { ServiceTestimonials } from "@/components/ServiceTestimonials";
import { laserDentistryData } from "./laserDentistryData";

export const LaserDentistryTestimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <ServiceTestimonials 
          testimonials={laserDentistryData.testimonials}
          title="Patient Testimonials"
          subtitle="What Our Patients Say"
        />
      </div>
    </section>
  );
};
